'use client';

import createSvg from './createSvg';

export default createSvg(({ height, width, className, ...props }) => (
  <svg
    height={height || 28}
    width={width || 20}
    {...props}
    viewBox="0 0 20 24"
    className={className}
    fill="none"
  >
    <path
      fill="#02C874"
      fillRule="evenodd"
      stroke="white"
      strokeLinejoin="round"
      d="M19 9v.12l-.02 3.21v.12l-.03 1.04a7.35 7.35 0 0 1-1.52 4.03 14.07 14.07 0 0 1-4.88 4.1c-.65.35-1.36.66-2.03.96l-.5.22H10a17.5 17.5 0 0 1-6.44-4.08 8.43 8.43 0 0 1-2.54-5.93C1 10.81 1 8.8 1 6.85V4.77c2.97-.2 5.8-1.32 8.9-3.5l.1-.07.1.07a18.56 18.56 0 0 0 6.67 3.16c.6.13 1.2.2 1.78.28l.45.05V9Z"
      clipRule="evenodd"
    />
    <path
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m6.4 12.4 2.4 2.4 5.4-6"
    />
  </svg>
));
